"use strict";

let dateFormat  = require('dateformat');

module.exports.timestampToDateFilter = (timestamp) => {
    let date = new Date(timestamp * 1000);
    let str = dateFormat(date, "yyyy-mm-dd HH:MM:ss");
    return `${str} [${timestamp}]`;
};



// WEBPACK FOOTER //
// ./src/lib/ucp/utils/timestamp-util.js